import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { FaMicrophone } from "react-icons/fa";
import { MdPhone } from "react-icons/md";
import { TbMessageChatbot } from "react-icons/tb";
import { IoSend } from "react-icons/io5";

const VoicePreview = ({ assistantName }) => (
  <Box
    w="320px"
    h="560px"
    bg="#1a1a2e"
    borderRadius="40px"
    p={6}
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="space-between"
    boxShadow="0 20px 60px rgba(0,0,0,0.4)"
    position="relative"
    overflow="hidden"
  >
    <Text fontSize="xs" color="gray.400" letterSpacing={2} textTransform="uppercase" mt={2}>
      Ready to Test
    </Text>

    {/* Avatar circle */}
    <Box
      w="120px"
      h="120px"
      borderRadius="full"
      bg="gray.700"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Icon as={FaMicrophone} boxSize={10} color="gray.400" />
    </Box>

    <Box textAlign="center">
      <Text color="white" fontWeight="bold" fontSize="xl">{assistantName || "Assistant"}</Text>
      <Text color="purple.300" fontSize="sm" mt={1}>Ava (Female)</Text>
    </Box>

    {/* Call button */}
    <Box
      w={16}
      h={16}
      borderRadius="full"
      bg="green.400"
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      boxShadow="0 0 20px rgba(72, 187, 120, 0.5)"
      mb={4}
    >
      <Icon as={MdPhone} boxSize={7} color="white" />
    </Box>
  </Box>
);

const ChatPreview = ({ assistantName }) => (
  <Box
    w="360px"
    h="560px"
    borderRadius="xl"
    overflow="hidden"
    boxShadow="0 20px 60px rgba(0,0,0,0.15)"
    display="flex"
    flexDirection="column"
    bg="white"
  >
    {/* Header */}
    <Flex
      bg="blue.500"
      px={4}
      py={3}
      alignItems="center"
      gap={3}
    >
      <Box w={9} h={9} borderRadius="full" bg="blue.400" display="flex" alignItems="center" justifyContent="center">
        <Icon as={TbMessageChatbot} color="white" boxSize={5} />
      </Box>
      <Box>
        <Text color="white" fontWeight="bold" fontSize="sm">{assistantName || "Assistant"} (Preview)</Text>
        <Text color="blue.100" fontSize="xs">Test your changes instantly</Text>
      </Box>
    </Flex>

    {/* Messages */}
    <Box flex={1} p={4} bg="gray.50" overflowY="auto" display="flex" flexDirection="column" gap={3}>
      <Text fontSize="xs" color="gray.400" textAlign="center">TODAY 10:42 AM</Text>
      <Flex gap={2}>
        <Box w={8} h={8} borderRadius="full" bg="blue.500" flexShrink={0} display="flex" alignItems="center" justifyContent="center">
          <Icon as={TbMessageChatbot} color="white" boxSize={4} />
        </Box>
        <Box bg="white" px={3} py={2} borderRadius="lg" fontSize="sm" maxW="75%" boxShadow="sm">
          Hi there! How can I help you today?
        </Box>
      </Flex>
    </Box>

    {/* Input */}
    <Flex px={4} py={3} borderTop="1px solid" borderColor="gray.100" gap={2} alignItems="center">
      <Box flex={1} bg="gray.100" borderRadius="full" px={4} py={2} fontSize="sm" color="gray.400">
        Type a message to test...
      </Box>
      <Box
        w={9}
        h={9}
        borderRadius="full"
        bg="blue.500"
        display="flex"
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
      >
        <Icon as={IoSend} color="white" boxSize={4} />
      </Box>
    </Flex>
  </Box>
);

const WidgetPreview = ({ isVoice, assistantName }) => (
  <Box>
    {isVoice ? (
      <VoicePreview assistantName={assistantName} />
    ) : (
      <ChatPreview assistantName={assistantName} />
    )}
  </Box>
);

export default WidgetPreview;
